import { Dialog, DialogContent, Box, Typography, DialogActions, FormHelperText, Button, TextField, Alert } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { setSiteDetailsData } from '../../../redux/siteDetailsDataSlice';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import { useState } from 'react';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/sites/updateSiteName.css';

export const UpdateSiteName = ({ modifyName, setModifyName }) => {

    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const [errMsg, setErrMsg] = useState('');
    const siteDetailsData = useSelector((state) => state.SiteDetailsData);

    const formik = useFormik({
        initialValues: {
            name: siteDetailsData?.name || '',
            description: siteDetailsData?.description || '',
        },
        validationSchema: Yup.object().shape({
            name: Yup.string().required(t('isRequired')),
            description: Yup.string().optional(),
        }),
        onSubmit: async (values) => {
            try {
                const response = await axios.patch(`site/site_name/${id}`, values);
                if (response.status === 200 || response.status === 201) {
                    dispatch(setSuccessfullModifyDialog({ open: true, type: "Modifier le nom et la description du site" }));
                    dispatch(setSiteDetailsData({ ...siteDetailsData, name: response?.data?.name || '', description: response?.data?.description || '' }));
                    setModifyName(false);
                }
            } catch (error) {
                console.error('Error updating site name:', error);
                setErrMsg(error?.response?.data?.message || error.message || 'Erreur lors de la modification du nom et de la description du site');
            }
        },
    });

    const { handleSubmit, values, handleChange, handleBlur, touched, errors } = formik;

    return (
        <Dialog open={modifyName} fullWidth>
            <Box onClick={() => setModifyName(false)} className='updateSiteName_icon_text'>
                <Typography className='updateSiteName_title'>{t("Modifier le nom et la description du site")}</Typography>
                <Iconify icon={"material-symbols:close"} className='updateSiteName_close_icon' />
            </Box>
            {errMsg && <Alert key={errMsg} severity="error">{errMsg}</Alert>}
            <form onSubmit={handleSubmit}>
                <DialogContent className='updateSiteName_dialog_content' >
                    <Box className="updateSiteName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateSiteNameInputTitle">{t('Nom')}</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.name}
                            className='updateSiteName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="name"
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                    <Box className="updateSiteName_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="updateSiteNameInputTitle">{t('Description')} (optionnel)</FormHelperText>
                        <TextField
                            fullWidth
                            value={values.description}
                            className='updateSiteName_InputField'
                            id="outlined-adornment-weight"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            name="description"
                            error={touched.description && Boolean(errors.description)}
                            helperText={touched.description && errors.description}
                            aria-describedby="outlined-weight-helper-text"
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='updateSiteName_dialog_actions'>
                    <Button className='updateSiteName_button_annuler' onClick={() => setModifyName(false)}>{t('Annuler')}</Button>
                    <Button className='updateSiteName_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};